import { createAction } from '@reduxjs/toolkit';

export const contextOnLogs = createAction<{serverId: string, content: string, append: boolean}>('context_on_logs');

export default {
  contextOnLogs
};
